export default "__VITE_ASSET__8992d709__"